import { gql, useMutation } from '@apollo/client';
import { CampaignAlert } from 'modules/campaigns/alerts/types';

const mutation = gql`
  mutation CreateAndScheduleCampaignAlertsRequest($campaignId: Long!) {
    createAndScheduleCampaignAlerts(value: $campaignId) {
      metricName
      comparisonOperator
      threshold
      frequency
    }
  }
`;

export type UseCreateAndScheduleCampaignAlertsResponse = {
  createAndScheduleCampaignAlerts: CampaignAlert[];
};

export type UseCreateAndScheduleCampaignAlertsVariables = {
  campaignId: number;
};

export const useCreateAndScheduleCampaignAlertsMutation = () => {
  const [createAndScheduleCampaignAlerts, { loading }] = useMutation<
    UseCreateAndScheduleCampaignAlertsResponse,
    UseCreateAndScheduleCampaignAlertsVariables
  >(mutation, {
    notifyOnNetworkStatusChange: true,
  });

  return {
    createAndScheduleCampaignAlerts,
    isLoading: loading,
  };
};
